<template>
  <div class="review-sort-menu">
    <div
      ref="refToggleState"
      class="menu-trigger bb-row bb-align-items-center bb-cursor-pointer"
      @click="toggleShowList"
    >
      <span class="trigger-text bb-mr-2">Ordenar por</span>
      <div
        class="chevron-icon bb-fcenter"
        :class="{ 'chevron-rotate': showList }"
        v-html="icons.chevron"
      ></div>
    </div>
    <transition name="fade">
      <div v-if="showList" class="dropdown-menu bb-mt-2 bb-border-radius-4">
        <ul class="options-list">
          <li
            v-for="option in sortOptions"
            :key="option.value"
            class="option-item bb-cursor-pointer"
            :class="{ 'option-selected': selectedSort === option.value }"
            @click="selectOption(option)"
          >
            {{ option.label }}
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
  import useToggleState from 'composables/useToggleState';
  import chevronIcon from 'common/icons/Chevron.svg';

  export default {
    name: 'ReviewSortMenu',
    props: {
      value: {
        type: String,
        default: 'last-reviews',
      },
    },
    setup() {
      const {
        showMenu: showList,
        toggleMenu: toggleShowList,
        refToggleState,
      } = useToggleState();

      return {
        showList,
        toggleShowList,
        refToggleState,
      };
    },
    data() {
      return {
        icons: {
          chevron: chevronIcon,
        },
        sortOptions: [
          { label: 'Más recientes', value: 'last-reviews' },
          { label: 'Más útiles', value: 'most-useful' },
          { label: 'Mayor puntaje', value: 'highest-score' },
          { label: 'Menor puntaje', value: 'lowest-score' },
        ],
        selectedSort: this.value,
      };
    },
    methods: {
      selectOption(option) {
        this.selectedSort = option.value;
        this.$emit('change', option.value);
        this.toggleShowList();
      },
      handleBodyScroll(shouldDisable) {
        const reviewsContainer = document.querySelector('.newReviewsContainer');

        if (shouldDisable) {
          document.body.style.overflow = 'hidden';
          if (reviewsContainer) {
            reviewsContainer.style.overflow = 'hidden';
          }
        } else {
          document.body.style.overflow = '';
          if (reviewsContainer) {
            reviewsContainer.style.overflow = '';
          }
        }
      },
    },
    watch: {
      value(newValue) {
        this.selectedSort = newValue;
      },
      showList(newValue) {
        this.handleBodyScroll(newValue);
      },
    },
    beforeUnmount() {
      // Asegurar que se restaure el scroll al desmontar el componente
      this.handleBodyScroll(false);
    },
  };
</script>

<style lang="scss" scoped>
  @import '~assets/styles/index.scss';

  .review-sort-menu {
    position: relative;
    width: fit-content;

    .menu-trigger {
      .trigger-text {
        color: var(--Primary-130, #222);
        text-align: center;
        font-family: 'Figtree', sans-serif;
        font-size: 16px;
        font-weight: 500;
        line-height: 20px;
      }

      .chevron-icon {
        transition: transform 0.3s ease;
        width: 14px;
        height: 7px;
        flex-shrink: 0;
        ::v-deep svg {
          width: 100%;
          height: 100%;

          path {
            fill: #5858da;
          }
        }

        &.chevron-rotate {
          transform: rotate(180deg);
        }
      }
    }

    .dropdown-menu {
      position: absolute;
      top: 100%;
      right: 0;
      background: white;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
      z-index: 100;
      min-width: 160px;

      .options-list {
        list-style: none;
        padding: 12px 0;
        margin: 0;

        .option-item {
          padding: 8px 16px;
          font-size: 14px;
          color: $DARK-GRAY;
          transition: background-color 0.2s ease;

          &:hover {
            background-color: #f5f5f5;
          }

          &.option-selected {
            font-weight: 600;
          }
        }
      }
    }

    .fade-enter-active,
    .fade-leave-active {
      transition: opacity 0.2s ease;
    }

    .fade-enter,
    .fade-leave-to {
      opacity: 0;
    }
  }
</style>
